'use strict';

angular.module('chatEngine.tos', [])

.controller('TOSCtrl', ['$scope', '$rootScope', '$window', '$http', '$location', 'Dialog', 'storageService',
    function($scope, $rootScope, $window, $http, $location, Dialog, storageService) {
    $scope.accept = function() {
        $http.post('/api/v1/tos')
        .success(function() {
            // The user just accepted the terms of service, so no matter what we don't care about the page they were
            // trying to visit and redirect them to the getting started page.
            $location.path('/docs/getting-started');
            storageService.removeItem('last-route');
        })
        .error(function() {
            Dialog.alert('Error', 'Something went wrong, please try again later.');
        });
    };

    $scope.decline = function() {
        Dialog.alert('Terms Declined', 'To use the Bot Dashboard you must accept the Terms of Service.' +
            ' Please contact <a href="mailto:bots@kik.com">bots@kik.com</a> if you have any questions.');
    };

    $scope.termsUrl = function() {
        return 'data:text/html,' + angular.element('#tos .tos-content').html();
    };
}]);
